import { Component } from '@angular/core';

@Component({
    selector: 'ms-speed-reading-result-row',
    templateUrl: './speed-reading-result-row.component.html',
    styleUrls: ['./speed-reading-result-row.component.scss'],
    standalone: false
})
export class SpeedReadingResultRowComponent {

}
